var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('HeaderBar',{attrs:{"title":_vm.hTitle}}),_vm._l((_vm.items),function(item,i){return _c('div',{key:i,staticClass:"my-2 text-xl text-justify border-b border-gray-300 pb-10"},[_vm._v(" "+_vm._s(item.content)+" ")])})],2)}
var staticRenderFns = []

export { render, staticRenderFns }